// extracted by mini-css-extract-plugin
module.exports = {"header":"MModal_header__z_MUr","body":"MModal_body__3fOQM"};